import { getConfigApi } from '../config'
import { getFetch, postFetch, putFetch, deleteFetch } from 'utils/fetch'
import { ApplicationType } from '../constants/type'
import { pathFetch } from '../utils/fetch'

function getUrl(prefix = '') {
  return getConfigApi().organization + '/' + prefix
}

export function getOrganizations(
  { itemPerPage = 10, page = 1 },
  { name, address, addressAPI, phone, status }
) {
  var urlSearch = getUrl(`?itemPerPage=${itemPerPage}&page=${page}`)
  if (name) urlSearch += `&name=${name}`
  if (address) urlSearch += `&address=${address}`
  if (addressAPI) urlSearch += `&addressAPI=${addressAPI}`
  if (phone) urlSearch += `&phone=${encodeURIComponent(phone)}`
  if (status) urlSearch += `&status=${encodeURIComponent(status)}`
  return getFetch(urlSearch)
}

export function create(data) {
  return postFetch(getUrl(), data)
}

export function getOne(_id) {
  return getFetch(getUrl(_id))
}

export function updateOne(_id, organization = {}) {
  return putFetch(getUrl(_id), organization)
}

export function removeOne(_id) {
  return deleteFetch(getUrl(_id))
}

export function deleteOne(_id) {
  return putFetch(getUrl(`delete/${_id}`))
}

export function restoreOne(_id) {
  return putFetch(getUrl(`restore/${_id}`))
}

export const refreshLanguage = (params) => {
  const url = `${getConfigApi().gateway}/no-auth/organization/remove-language`
  return pathFetch(url, params)
}

export const toggleWarningUpdateVersion = (isWarning) => {
  return pathFetch(getUrl(`warningNewUpdated/${isWarning}`))
} 

export function updateMenu(_id, menu = {}, applicationType = ApplicationType.Web) {
  const pathMenu = applicationType === ApplicationType.Web ? 'menu' : 'menuMobile'
  return putFetch(getUrl(`${pathMenu}/${_id}`), menu)
}

export default {
  getOrganizations,
  create,
  getOne,
  updateOne,
  deleteOne,
  restoreOne,
  removeOne,
  updateMenu,
  refreshLanguage
}



// WEBPACK FOOTER //
// ./src/api/OrganizationApi.js